import { Component, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";

export abstract class AutoUnsubscribe  {
    protected subscriptions: Subscription[] = [];

    protected addSubscription(subscription: Subscription) {
      this.subscriptions.push(subscription);
    }
  
    protected onDestroy() {
        for (const sub of this.subscriptions) {
            sub.unsubscribe();
        }
    }
}

@Component({
    template: '',
})
export abstract class AutoUnsubscribeComponent extends AutoUnsubscribe implements OnDestroy{
    ngOnDestroy(): void {
        super.onDestroy();
    }
}